import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/lib/api";

export default function SEO({ title, description, schema }) {
  const location = useLocation();
  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.name;
  const currentUrl = `${SITE.domain}${location.pathname}`;

  useEffect(() => {
    // Set title
    document.title = fullTitle;

    // Helper to set meta tags
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? "property" : "name";
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Description
    setMeta("description", description || SITE.description);

    // OpenGraph
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", description || SITE.description, true);
    setMeta("og:url", currentUrl, true);
    setMeta("og:type", "website", true);

    // Schema.org JSON-LD
    let script = document.querySelector('script[type="application/ld+json"]');
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }

    return () => {
      if (script) script.remove();
    };
  }, [fullTitle, description, currentUrl, schema]);

  return null;
}
